import request from '@/utils/request'
import data from '@/views/permission/permission-manage/data'
import qs from 'qs'

const MOCK_URL: string = ''
// 渠道 - 列表
export const getChannelList = (data: any) =>
  request({
    url: 'resourcePlace/list',
    method: 'get',
    params: data
  })
// 资源位（批量）置顶, 这里 nid 可以传 string, 后台转了
export const setAppTop = (data: { nid: string, ids: string, isTop: 1 }) =>
  request({
    url: '/resourcePlace/top',
    method: 'post',
    data: qs.stringify(data)
  })
// 资源位（批量）删除
export const setAppDelete = (data: { nid: string, ids: string }) =>
  request({
    url: '/resourcePlace/delete',
    method: 'post',
    data: qs.stringify(data)
  })

// 渠道资源位-获取编辑数据
export const getChannelAppInfo = (data: { id: any, platform: any, nid: any }) =>
  request({
    url: '/resourcePlace/editInfo',
    method: 'get',
    params: data
  })
// 资源位新增,修改
interface IAddEdit {
  ids: string
  nids: string
  startDate: string
  endDate: string
  isShow: boolean
  bannerType: string
  bannerSort: number
  position: string
  bannerId: number
  img: string
  platform: 'ios' | 'android'
}
export const addChannel = (data: IAddEdit) =>
  request({
    url: '/resourcePlace/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
export const editChannel = (data: IAddEdit) =>
  request({
    url: '/resourcePlace/update',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })

// 拖动排序
export const dragSort = (data: any) =>
  request({
    url: `/resourcePlace/swap`,
    method: 'post',
    data: qs.stringify(data)
  })

interface copyParams {
  'src_nid': number,
  'dst_nid': number
}
// 复制渠道
export const copyChannel = (data: copyParams) =>
  request({
    url: `/resourcePlace/copy`,
    method: 'post',
    data: qs.stringify(data)
  })

export const getChannelConfig = (params: any) =>
  request({
    url: '/resourcePlace/getClientListParams',
    method: 'get',
    params
  })

export const setChannelConfig = (data: any) =>
  request({
    url: '/resourcePlace/saveClientListParams',
    method: 'post',
    data: qs.stringify(data)
  })

export const moveChannels = (data: any) =>
  request({
    url: '/resourcePlace/swap',
    method: 'post',
    data: qs.stringify(data)
  })

interface randomParams {
  'addr_seq': string,
  nid: number|string
}
export const randomChannels = (data: randomParams) =>
  request({
    url: '/resourcePlace/random',
    method: 'post',
    data: qs.stringify(data)
  })
